import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ColorTagComponent } from '@shared/components/color-tag/color-tag.component';
import { DividerComponent } from '@shared/components/divider/divider.component';
import { IsNewTagComponent } from '@shared/components/is-new-tag/is-new-tag.component';
import { INews_Item, ITagGroup } from '@shared/constants/models.const';
import { OnlyDate } from '@shared/pipes/only-date';

@Component({
  selector: 'app-tag-section',
  imports: [
    ColorTagComponent,
    DividerComponent,
    IsNewTagComponent,
    OnlyDate,
  ],
  templateUrl: './tag-section.component.html',
  styleUrl: './tag-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagSectionComponent {
  news = input.required<INews_Item | any>();
  showFullTagList = input(false);
  customDateField = input<string>('');
  withBMargin = input(true);
  tagGroups = computed(() => {
    let tagGroups: ITagGroup[] = [];
    if (this.news() && this.news().tagGroups && this.news().tagGroups.length > 0) {
      tagGroups = this.news().tagGroups.filter((item: ITagGroup) => {
        return !!item.name && !!item.color;
      });
    }
    return tagGroups;
  });
  protected readonly computed = computed;
}
